export function displayOptions(): DisplayMediaStreamOptions {
  return {
    video: { width: { ideal: 1280 }, height: { ideal: 720 }, frameRate: { ideal: 24, max: 30 } },
    audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false },
    systemAudio: "include", selfBrowserSurface: "exclude", surfaceSwitching: "exclude",
  } as DisplayMediaStreamOptions;
}
export function screenAudio(stream: MediaStream): "included" | "missing" | "paused" {
  const tracks = stream.getAudioTracks().filter(track => track.readyState !== "ended");
  return !tracks.length ? "missing" : tracks.every(track => track.muted || !track.enabled) ? "paused" : "included";
}
